import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    MDBBtn,
    MDBIcon,
    MDBTable,
    MDBTableBody,
    MDBTableHead,
    MDBTooltip,
    MDBModal,
    MDBModalDialog,
    MDBModalContent,
    MDBModalHeader,
    MDBModalTitle,
    MDBModalBody,
    MDBModalFooter,
    MDBInput
} from "mdb-react-ui-kit";

export default function QrEventTable() {
    const [events, setEvents] = useState([]);
    const [modal, setModal] = useState(false);
    const [linkModal, setLinkModal] = useState(false); // 링크 생성 모달 관리
    const [modalType, setModalType] = useState("");
    const [currentEvent, setCurrentEvent] = useState({
        eventName: "",
        date: "",
        place: "",
        client: ""
    });

    const fetchEvents = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-events/list`);
            setEvents(response.data);
        } catch (error) {
            console.error("이벤트를 가져오는 중 오류가 발생했습니다.", error);
        }
    };

    useEffect(() => {
        fetchEvents();
    }, []);

    const toggleModal = (type = "", event = {}) => {
        setModal(!modal);
        setModalType(type);
        setCurrentEvent(event);
    };

    const toggleLinkModal = (event) => {
        setLinkModal(!linkModal);
        setCurrentEvent(event);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentEvent((prev) => ({ ...prev, [name]: value }));
    };

    const handleSave = async () => {
        if (!currentEvent.eventName || !currentEvent.date || !currentEvent.place || !currentEvent.client) {
            alert("모든 필드를 채워주세요.");
            return;
        }

        try {
            toggleModal();
            if (modalType === "add") {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-events/create`, currentEvent);
                alert("추가가 완료되었습니다")
            } else if (modalType === "edit") {
                await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-events/update`, currentEvent);
                alert("수정이 완료되었습니다")
            }
            fetchEvents();
        } catch (error) {
            console.error("이벤트 저장 중 오류가 발생했습니다.", error);
            alert("중복되는 행사명이거나 서버 오류가 발생했습니다.")
        }
    };

    const handleDelete = async () => {
        try {
            toggleModal();
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/qr-events/delete`, currentEvent);
            alert("삭제가 완료되었습니다")
            fetchEvents();
        } catch (error) {
            console.error("이벤트 삭제 중 오류가 발생했습니다.", error);
            alert("행사 삭제 중 오류가 발생했습니다")
        }
    };

    return (
        <div className='center-text'>
            <MDBTable responsive="lg" hover>
                <MDBTableHead>
                    <tr>
                        <th scope="col">행사명
                            <MDBTooltip tag="a" wrapperProps={{ href: "#" }} title="참가자 등록할 때 표시되는 이름이에요">
                                <MDBIcon far icon="question-circle" />
                            </MDBTooltip>
                        </th>
                        <th scope="col">행사 일시</th>
                        <th scope="col">행사 위치</th>
                        <th scope="col">발주처</th>
                        <th scope="col">관리</th>
                    </tr>
                </MDBTableHead>
                <MDBTableBody style={{ textAlign: "center", verticalAlign: "middle" }}>
                    {events.map((event, index) => (
                        <tr key={index}>
                            <td>{event.eventName}</td>
                            <td>{event.date}</td>
                            <td>{event.place}</td>
                            <td>{event.client}</td>
                            <td>
                                <MDBBtn color="info" size="sm" onClick={() => toggleModal("edit", event)}>
                                    수정
                                </MDBBtn>{" "}
                                <MDBBtn color="danger" size="sm" onClick={() => toggleModal("delete", event)}>
                                    삭제
                                </MDBBtn>{" "}
                                <MDBBtn color="primary" size="sm" onClick={() => toggleLinkModal(event)}>
                                    링크 생성
                                </MDBBtn>
                            </td>
                        </tr>
                    ))}
                </MDBTableBody>
            </MDBTable>

            <div style={{ display: "flex", justifyContent: "flex-end", paddingRight: "30px" }}>
                <MDBBtn color="success" onClick={() => toggleModal("add")}>
                    행사 추가
                </MDBBtn>
            </div>

            {/* 기존 모달 */}
            <MDBModal open={modal} onClose={() => setModal(false)} tabIndex="-1">
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>
                                {modalType === "add" ? "행사 추가" : modalType === "edit" ? "행사 수정" : "행사 삭제"}
                            </MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => toggleModal()}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            {modalType === "delete" ? (
                                <p>정말로 '{currentEvent.eventName}' 행사를 삭제하시겠습니까?</p>
                            ) : (
                                <>
                                    <MDBInput
                                        label="행사명"
                                        name="eventName"
                                        value={currentEvent.eventName}
                                        onChange={handleInputChange}
                                        disabled={modalType === "edit"}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="행사 일시"
                                        type="date"
                                        name="date"
                                        value={currentEvent.date}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="행사 위치"
                                        name="place"
                                        value={currentEvent.place}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                    <MDBInput
                                        label="발주처"
                                        name="client"
                                        value={currentEvent.client}
                                        onChange={handleInputChange}
                                        className="mb-3"
                                    />
                                </>
                            )}
                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={() => toggleModal()}>
                                취소
                            </MDBBtn>
                            {modalType === "delete" ? (
                                <MDBBtn color="danger" onClick={handleDelete}>
                                    삭제
                                </MDBBtn>
                            ) : (
                                <MDBBtn color="primary" onClick={handleSave}>
                                    저장
                                </MDBBtn>
                            )}
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>

            {/* 링크 생성 모달 */}
            <MDBModal open={linkModal} onClose={() => setLinkModal(false)} tabIndex="-1">
                <MDBModalDialog centered>
                    <MDBModalContent>
                        <MDBModalHeader>
                            <MDBModalTitle>링크 생성</MDBModalTitle>
                            <MDBBtn className="btn-close" color="none" onClick={() => setLinkModal(false)}></MDBBtn>
                        </MDBModalHeader>
                        <MDBModalBody>
                            <p><strong>참가 신청 폼 링크:</strong></p>
                            <MDBInput
                                type="text"
                                value={`https:://onandme.info/qr-event-participant-request/${currentEvent.eventName}`}
                                readOnly
                            />

                            <p className="mt-4"><strong>참가 내역 확인 페이지 링크:</strong></p>
                            <MDBInput
                                type="text"
                                value={`https:://onandme.info/qr-event-participant-check/${currentEvent.eventName}`}
                                readOnly
                            />

                        </MDBModalBody>
                        <MDBModalFooter>
                            <MDBBtn color="secondary" onClick={() => setLinkModal(false)}>닫기</MDBBtn>
                        </MDBModalFooter>
                    </MDBModalContent>
                </MDBModalDialog>
            </MDBModal>
        </div>
    );
}